// extracted by mini-css-extract-plugin
export default {"card":"Feedback_card__AXFtO"};